export default [
  'OneColumnMobileLoginPage'
]

/*
Appears on:
/login-mobile
*/
